<template>
  <div
    class="page-article-detail"
    :class="{'page-article-detail--empty': articleData.isNotExist}"
  >
    <div
      v-if="articleData.isNotExist"
      class="empty-status-wrap__container"
    >
      <div class="empty-status-wrap__img-container">
        <img src="@/assets/image/article/not-exist.png">
        <p>文章不存在</p>
      </div>
      <v-btn
        class="empty-status-wrap__btn"
        depressed
        color="primary"
        @click="goInformationStation"
      >
        查看其他文章
      </v-btn>
    </div>
    <template v-else>
      <div class="page-article-detail__top-container">
        <div class="page-article-detail__left-section">
          <div v-if="$fetchState.pending">
            <v-skeleton-loader
              type="article, list-item-three-line"
            />
            <v-skeleton-loader
              type="list-item-three-line"
            />
            <v-skeleton-loader
              type="list-item-three-line"
            />
          </div>
          <template v-else>
            <ArticleTitle
              class="page-article-detail__left-section__article-title"
              :content="articleData"
            />
            <div
              class="page-article-detail__left-section__article-content"
              v-html="articleData.Content"
            />
          </template>
        </div>
        <div class="page-article-detail__right-section">
          <div v-if="$fetchState.pending">
            <v-skeleton-loader
              type="list-item-avatar-three-line"
            />
          </div>
          <ArticleAuthorCard
            v-else-if="articleData.SourceInfo"
            class="page-article-detail__author-card"
            :content="articleData.SourceInfo"
          />
        </div>
      </div>
      <div
        v-if="!$fetchState.pending"
        class="section-spacer"
      />
      <div
        v-if="!$fetchState.pending"
        class="page-article-detail__bottom-container"
      >
        <div class="page-article-detail__left-section">
          <SectionTitle
            class="page-article-detail__left-section__related-title"
            title="相關文章"
          />
          <div class="page-article-detail__left-section__related-articles">
            <ArticleCard
              v-for="(article, i) in relatedArticles"
              :key="i"
              class="article"
              :content="article"
              :display="isMobile ? 'column' : 'row'"
              :img-width="isMobile ? '' : '250px'"
              :img-height="isMobile ? '' : '120px'"
              :aspect-ratio="isMobile ? 25 / 12 : 0"
              :show-content="false"
              :show-title-on-img="false"
              @click.native="goArticlePage(article)"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import SectionTitle from '@/components/ComponentSectionTitle.vue'
import defaultArticleImg from '@/assets/image/article/default-cover.png'
import { mapGetters } from 'vuex'
import ArticleTitle from '@/components/PageComponent/ArticleSection/ArticleTitle'
import ArticleCard from '@/components/PageComponent/ArticleSection/ArticleCard'
import ArticleAuthorCard from '@/components/PageComponent/ArticleSection/ArticleAuthorCard'
export default {
  components: {
    SectionTitle,
    ArticleTitle,
    ArticleCard,
    ArticleAuthorCard
  },
  data () {
    return {
      title: '',
      description: '',
      articleData: {
        isNotExist: false,
        Title: '',
        Summary: '',
        Content: '',
        MainType: {
          Id: 0,
          Name: ''
        },
        SubType: {
          Id: 0,
          Name: ''
        },
        CreateAt: '',
        SourceInfo: {
          Id: 0,
          Name: '',
          About: '',
          LogoImageUrl: '',
          RelatedLink: ''
        },
        CoverPictureUrl: ''
      },
      relatedArticles: []
    }
  },
  head () {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'description', name: 'description', content: this.description },
        { hid: 'og:url', property: 'og:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'og:title', property: 'og:title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'og:description', property: 'og:description', content: this.description },
        { hid: 'og:image', property: 'og:image', content: this.image },
        { hid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
        { hid: 'twitter:url', property: 'twitter:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'twitter:title', property: 'twitter:title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'twitter:description', property: 'twitter:description', content: this.description },
        { hid: 'twitter:image', property: 'twitter:image', content: this.image }
      ]
    }
  },
  jsonld () {
    const baseUrl = String(this.$nuxt.context.env.BASE_WEB_URL || ' ').slice(0, -1)
    const homePageRouteData = this.$nuxt.$router.resolve({
      name: 'home'
    })
    const homePageUrl = baseUrl + homePageRouteData.resolved.fullPath
    const listPageRouteData = this.$nuxt.$router.resolve({
      name: 'informationStation'
    })
    const listPageUrl = baseUrl + listPageRouteData.resolved.fullPath
    const currentPageRouteData = this.$nuxt.$router.resolve({
      name: 'informationStation-article-idsn',
      params: { idsn: this.articleId }
    })
    const currentPageUrl = baseUrl + currentPageRouteData.resolved.fullPath
    const getBreadcrumbList = () => {
      return [
        {
          '@type': 'ListItem',
          position: 1,
          name: '智樂家',
          item: homePageUrl
        }, {
          '@type': 'ListItem',
          position: 2,
          name: '生活情報站',
          item: listPageUrl
        }, {
          '@type': 'ListItem',
          position: 3,
          name: this.title,
          item: currentPageUrl
        }
      ]
    }
    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'BreadcrumbList',
          itemListElement: getBreadcrumbList()
        },
        {
          '@type': 'NewsArticle',
          headline: this.articleData.Title,
          datePublished: this.articleData.CreateAt,
          image: [this.articleData.CoverPictureUrl],
          author: [{
            '@type': 'Person',
            name: this.articleData.SourceInfo.Name,
            url: this.articleData.SourceInfo.RelatedLink || ''
          }]
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'isMobile'
    ])
  },
  updated () {
    this.$nextTick(() => {
      for (const item of document.querySelectorAll('.page-article-detail__left-section__article-content a')) {
        if (item.href) {
          console.log(item.href)
          const splitPath = item.href.split('://')
          const isValidUrl = () => {
            return splitPath[0] === 'https' && splitPath[1]?.includes('inapp.kingnetsmart.com.tw') &&
              (
                (splitPath[1]?.includes('LS_A_Intro') && splitPath[1]?.includes('params1')) ||
                (splitPath[1]?.includes('LS_A_Clist') && splitPath[1]?.includes('params2'))
              )
          }
          if (isValidUrl()) {
            item.addEventListener('click', (e) => {
              e.preventDefault()
              const urlPath = new URL(item.href)
              const searchParams = urlPath.searchParams // 跳轉參數
              const searchParamsObj = Object.fromEntries(searchParams)
              const page = searchParamsObj.page
              if (page === 'LS_A_Intro') {
                const serviceId = searchParamsObj.params1
                this.$nuxt.$router.push({ name: 'category-category-service', params: { service: serviceId } })
              } else if (page === 'LS_A_Clist') {
                const typeId = searchParamsObj.params2
                this.$nuxt.$router.push({ name: 'index-id', params: { toTop: true, id: typeId } })
              }
            })
          }
        }
      }
    })
  },
  async asyncData ({ env, route, params, store }) {
    const { idsn } = route.params
    return {
      articleId: idsn,
      routeFullPath: route.fullPath,
      webBaseUrl: String(env.BASE_WEB_URL || ' ').slice(0, -1)
    }
  },
  async fetch () {
    try {
      if (isNaN(+this.articleId)) {
        throw new Error('not exist')
      }
      this.$nuxt?.$loading?.start()
      await Promise.all([
        this.getArticleInfo(),
        this.getArticleViewCount(),
        this.getRelatedArticle()
      ])
      this.title = this.articleData.Title
      this.description = this.articleData.Summary
      this.image = this.articleData.CoverPictureUrl || this.$nuxt.context.env.BASE_WEB_URL.slice(0, -1) + defaultArticleImg
      this.$nextTick(() => {
        this.$nuxt?.$loading?.finish()
      })
    } catch (err) {
      if ([400001, 404001].includes(err?.response?.data?.ErrorMessage?.Code) || err.message === 'not exist') {
        this.articleData.isNotExist = true
      }
      this.$nuxt?.$loading?.finish()
    }
  },
  methods: {
    // api
    async getArticleInfo () {
      try {
        const postData = {
          ArticleId: this.articleId
        }
        const response = await this.$axios.get(`api/v1/Article/${this.articleId}`, { params: postData })
        const createSpliceAboutSourceWithLimitedLength = (count, key) => {
          const aboutSourse = response.data.Data.SourceInfo.About.slice(0, count)
          response.data.Data.SourceInfo[key] = response.data.Data.SourceInfo.About.length > count ? aboutSourse + '...' : aboutSourse
        }
        createSpliceAboutSourceWithLimitedLength(30, 'aboutSourseForMobile')
        createSpliceAboutSourceWithLimitedLength(60, 'aboutSourseForWeb')
        this.articleData = {
          ...this.articleData,
          ...response.data.Data
        }
      } catch (err) {
        console.log('err', err)
        return Promise.reject(err)
      }
    },
    async getArticleViewCount () {
      try {
        const postData = {
          ArticleId: this.articleId
        }
        const response = await this.$axios.get(`api/v1/Article/${this.articleId}/ViewingCount`, { params: postData })
        this.articleData.ViewCount = response.data.Data.ViewCount
      } catch (err) {
        console.log('err', err)
        return Promise.reject(err)
      }
    },
    async getRelatedArticle () {
      try {
        const postData = {
          ArticleId: this.articleId,
          Count: 2
        }
        const response = await this.$axios.get(`api/v1/Article/${this.articleId}/Relate`, { params: postData })
        this.relatedArticles = this.formatArticleData(response.data.Data.Articles)
      } catch (err) {
        console.log('err', err)
        return Promise.reject(err)
      }
    },
    goInformationStation () {
      this.$nuxt.$router.push({ name: 'informationStation' })
    },
    formatArticleData (articleData) {
      return articleData.map(data => {
        data.CreateTime = this.$dayjs(data.CreateAt).format('YYYY/MM/DD')
        if (!data.CoverPictureUrl) {
          data.CoverPictureUrl = require('@/assets/image/article/default-cover.png')
        }
        return data
      })
    },
    goArticlePage (article) {
      this.$gaLogEvent('文章頁', `相關文章_${article.Title}_${article.Id}`)
      this.$nuxt.$router.push({ name: 'informationStation-article-idsn', params: { idsn: article.Id } })
    }
  }
}
</script>

<style lang="scss">
.page-article-detail {
  @include empty-status-page;
  max-width: 75rem;
  margin: 3rem auto;
  padding: 0px 1rem;
  display: flex;
  flex-direction: column;
  &__top-container {
    display: flex;
    flex-direction: row;
  }
  .section-spacer {
    width: 66%;
    height: 8px;
    background-color: #efeff4;
    margin: 32px 0;
  }
  &__left-section {
    width: 66%;
    &__article-content {
      img {
        width: 100%;
      }
    }
    &__article-title {
      margin-bottom: 32px;
    }
    &__related-articles {
      .article {
        margin-bottom: 20px;
        +.article {
          padding-top: 20px;
          border-top: 1px solid $color-border-primary;
        }
      }
    }
    &__related-title {
      margin-bottom: 32px;
    }
  }
  &__right-section {
    width: 33%;
    .article-author-card {
      margin-left: auto;
    }
  }
}
/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .page-article-detail {
    &--empty {
      margin-top: 0;
      margin-bottom: 0;
      height: calc(100vh - #{$headerHeightMobile});
    }
    &__top-container {
      flex-direction: column;
    }
    &__left-section {
      width: 100%;
    }
    &__right-section {
      width: 100%;
    }
    &__author-card {
      width: 100%;
      margin: auto;
      margin-bottom: 8px;
    }
    .section-spacer {
      width: 100%;
    }
  }
}
</style>
